export default __webpack_public_path__ + "static/media/s3.7ad40481.jpg";